export class ScriptDTO {

    constructor(
      readonly fileName: string,
      readonly script: string
    ) {
    }
  }